import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import '../../sass/components/input/TextInput.scss';

const mapStoreToProps = (store) => {
  return {
    isMobile: store.setup.isMobile,
  }
};

class ObjectInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
    };
    this.input = null;
  }

  componentDidMount = () => {
  }

  renderTextInput = () => {
    const properties = this.props.properties;
    let value = this.props.object?.name;
    return (
      <input
        type={'text'}
        value={value}
        readOnly={true}
        className="form-control"
        placeholder={this.props.placeholder || properties.placeholder}
        ref={input => {
          this.input = input;
          if (this.props.inputRef) {
            this.props.inputRef(this.input);
          }
        }}
      />
    )
  }

  render = () => {
    const properties = this.props.properties;
    return (
      <div
        className={classnames({
          'textInput': true,
          'simplified': properties.simplified,
          [properties.type]: true,
          'error': this.props.error,
        })}
      >
        {this.renderTextInput()}
        {this.props.error && this.props.error.length ? 
          <div className='inputError'>{this.props.error}</div>
        : null}
      </div>
    )
  }
}

export default connect(mapStoreToProps)(ObjectInput);
